import $ from 'jquery';

const $input = $('input, textarea');

$input.on('focus', function(){
	$(this).closest('.gfield').find('label').addClass('away');
});

$input.on('blur', function(){
	if( !$(this).val() ){
		$(this).closest('.gfield').find('label').removeClass('away');
	}
});

$('input[type="file"]').on('focus', function(){
	$(this).closest('.gfield').find('label').addClass('focus');
});
$('input[type="file"]').on('blur', function(){
	$(this).closest('.gfield').find('label').removeClass('focus');
});
